import { PlainDatatypes } from '../../../datatype/Datatype';
import { createConditionOperator } from '../IConditionOperator';

export const ConditionOperatorNotEqualsType = createConditionOperator({
  code: 'notEquals',
  label: '≠',
  description: 'Diverso da',
  args: [{ type: 'referenceValue' }],
  allowsField: field => PlainDatatypes.includes(field.type),
  compare(value: any, [target]: [any]) {
    if (value == null && target == null) return false;
    return value !== target;
  },
});
